import roygoh from "../Assets/roygoh.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img className="card-img-style" src={roygoh} alt="judge picture"></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Roy Goh</h2>
        <br />
        <p className="card-sub-name-style">Director, MDS, AI Office, NUHS</p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Roy Goh</h2>
            <br />

            <h3>Director, MDS, AI Office, NUHS</h3>
            <br />
            <p>
              Roy Goh leads Management Decision Support, under AI Office at
              NUHS. His team manages in-house application development,
              cluster-level dashboards and decision sciences using AI tools. In
              addition, Roy holds multiple portfolios at NUHS, namely,
              Functional Group lead for NGEMR Reporting and Analytics, Working
              Committee Representative @ HEALIX (MOH’s data platform), NUHS C3
              Steering Committee member, Domain Data Advisor to the Community
              for Data-Driven Healthcare Innovation, etc.
              <br />
              <br />
              Prior to NUHS, Roy has extensive multi-national experiences. At
              MSD (US$64 billion revenue pharmaceutical), Roy pioneered Data
              Science team at IT Hub, leading 30 data science professionals to
              deliver best-in-class data science and AI solutions across Asia
              Pacific (inclusive of China and Japan). Members of that pioneering
              team have progressed to lead their own teams and are current
              thought leaders in the field of AI.
              <br />
              <br />
              Roy holds an MBA from the National University of Singapore.
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
